import * as styles from "./DataTableRow.css";

import { clsx } from "clsx";
import type { ComponentProps, JSX, ReactNode } from "react";

import type { DataTableVariant } from "./DataTable.types";

type DataTableRowProps = ComponentProps<"div"> & {
  gridTemplateColumns: string;
  variant?: DataTableVariant;
  header?: boolean;
  clickable?: boolean;
  active?: boolean;
  detail?: boolean;
  selected?: boolean;
  pinned?: boolean;
  striped?: boolean;
  children: ReactNode;
};

export function DataTableRow({
  gridTemplateColumns,
  variant = "default",
  header = false,
  clickable = false,
  active = false,
  detail = false,
  selected = false,
  pinned = false,
  striped = false,
  className,
  style,
  children,
  ...props
}: DataTableRowProps): JSX.Element {
  return (
    <div
      role="row"
      className={clsx(
        styles.row({
          variant,
          header,
          clickable,
          active,
          detail,
          selected,
          pinned,
          striped,
        }),
        className,
      )}
      style={{ gridTemplateColumns, ...style }}
      data-slot={header ? "data-table-header-row" : "data-table-row"}
      data-active={active ? "" : undefined}
      data-detail={detail ? "" : undefined}
      data-selected={selected ? "" : undefined}
      {...props}
    >
      {children}
    </div>
  );
}
